<app-manufacturer-matching-modal
  #unMatchModal
  [match]="app.manufacturerMatching.manufacturer"
  [type]="'discard'"
  >
</app-manufacturer-matching-modal>

<app-manufacturer-matching-modal
  #saveMatchModal
  [match]="app.externalDataFilter.currentMatch"
  [manufacturer]="app.manufacturerMatching.manufacturer"
  [type]="'save'"
  >
</app-manufacturer-matching-modal>

<app-create-manufacturer-modal
  #createManufacturer
  [modalMessage]="app.text.part.discard"
  [modalTitle]="app.text.part.modalTitle"
  (ok)="createManufacturer()"
></app-create-manufacturer-modal>

<div
  class="external-data-table-card"
  [class.external-data-table-card-has-results]="
    app.externalDataFilter.paginatedMatches.length > 0
  "
  [class.external-data-table-card-has-many-results]="
    app.externalDataFilter.paginatedMatches.length > 5
  "
  >
  <div class="external-data-table-card-header">
    <div class="external-data-table-card-title">
      @if (showHeaderTitle) {
        {{ app.text.thread.searchInComponent }}
      } @else {
        &nbsp;
      }
    </div>
  </div>

  <div class="external-table-toolbar">
    <div class="external-table-toolbar-row">
      <div class="external-search-box">
        <input
          type="text"
          class="form-control searchInput"
          [placeholder]="
            app.field.getLabel(app.fieldId.manufacturer.manufacturerPartNumber)
          "
          [(ngModel)]="partNumber"
          (keydown.enter)="searchManufacturer(partNumber)"
          (click)="app.filterTable.filterFocus = false"
          />
        <button
          class="btn external-search-button"
          (click)="searchManufacturer(partNumber)"
          >
          <i class="fa fa-search"></i>
          <span>{{ app.text.app.search }}</span>
        </button>
      </div>

      <div class="external-table-toolbar-actions">
        <button class="btn external-reset-link" (click)="resetAllFilters()">
          {{ app.text.RM.resetFilter }}
        </button>
      </div>
    </div>
  </div>

  <div class="tableFixHead external-table-scroll">
    <table class="table external-results-table">
      <thead>
        <tr>
          @for (column of columns; track column) {
            <th
            [ngClass]="{
              'text-center': column === 'createManufacturer',
            }"
              class="align-top table-header external-table-header-cell"
              >
              <div class="external-table-header-content">
                <div
                [ngClass]="{
                  'resize-table': app.table.canColumnBeResized(column),
                }"
                  >
                  @if (app.table.canColumnBeSorted(column)) {
                    <span
                    (click)="
                      app.table.toggleSortDirection(
                        app.manufacturerMatching.getColumn(column)
                      );
                      app.table.sort(
                        app.manufacturerMatching.manufacturer.matches
                      )
                    "
                      >
                      {{ app.field.handleSpecialLogicLabels(column) }}
                    </span>
                  } @else {
                    @switch (column) {
                      @case ('select') {
                        <span>
                          {{ app.field.handleSpecialLogicLabels(column) }}
                        </span>
                      }
                      @case ('datasheet') {
                        <span>
                          {{ app.field.handleSpecialLogicLabels(column) }}
                        </span>
                      }
                      @case ('suitable') {
                        <span>
                          <span class="d-block">
                            {{ app.field.handleSpecialLogicLabels(column) }}
                          </span>
                          <span class="d-flex align-items-center mt-1">
                            <input
                              type="checkbox"
                              class="me-1 suitable-checkbox"
                          [checked]="
                            suitableService.isAllSuitableChecked(
                              matchReviews,
                              app.manufacturerMatching.manufacturer.matches
                            )
                          "
                              [disabled]="isSavingSuitableState"
                              (click)="$event.stopPropagation()"
                              (change)="setAllSuitableValue($event)"
                              />
                            <span>{{ app.text.table.selectAll }}</span>
                          </span>
                        </span>
                      }
                      @case ('createCase') {
                        @if (app.permission.thread.hasPermissionToCreateThread) {
                          <span
                            (click)="$event.stopPropagation()"
                            >
                            <i class="fas fa-folders"></i>
                          </span>
                        }
                      }
                      @case ('createManufacturer') {
                        <span
                          [title]="app.text.manufacturer.createNewManufacturer"
                          >
                          <i class="fad fa-industry-alt"></i>
                        </span>
                      }
                      @case ('assignedTo') {
                        <span>
                          <i class="fas fa-sitemap fa-rotate-270"></i>
                        </span>
                      }
                    }
                  }
                </div>
                @if (
                  app.table.canColumnBeSorted(column) &&
                  app.manufacturerMatching.getColumn(column) ===
                  app.table.sortField
                  ) {
                  <span
                    class="external-sort-icon"
                    >
                    @if (app.table.sortDirection === 1) {
                      <i
                        class="fa fa-chevron-up"
                      ></i>
                    }
                    @if (app.table.sortDirection === -1) {
                      <i
                        class="fa fa-chevron-down"
                      ></i>
                    }
                  </span>
                }
              </div>
              @if (isFilterableColumn(column)) {
                <div>
                  <app-filter-table
                [column]="
                  getFilterColumn(column)
                "
                    [columns]="columnRows"
                    [docType]="'manufacturer'"
                    [cleanDocs]="app.externalDataFilter.matchesCopy"
                    [selectedFilters]="selectedFilters"
                    (resultedDocs)="onFilterResults($event)"
                    [resetComponent]="resetFilterInputsObservable"
                    >
                  </app-filter-table>
                </div>
              }
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (match of app.externalDataFilter.paginatedMatches; track match) {
          <tr
            class="external-result-row"
          [ngClass]="{
            'current-match-row': !showDefaultBtn(
              app.manufacturerMatching.manufacturer,
              match
            ),
          }"
            >
            @for (column of columnRows; track column) {
              <td
                class="external-table-cell"
            [ngClass]="{
              'text-center': column === 'Datasheet' || column === 'suitable',
              'disabled-match-cell':
                suitableService.isSuitableChecked(matchReviews, match) &&
                column !== 'suitable' &&
                column !== 'MatchReason' &&
                column !== 'matchReason',
              'suitable-cell-active': column === 'suitable',
            }"
                >
                @switch (column) {
                  @case ('createManufacturer') {
                    <a
                  [ngClass]="{
                    'btn-selected': match.isAdded,
                  }"
                      class="btn btn-sm btn-default-orange"
                  (click)="
                    app.manufacturer.selectedManufacturer = match;
                    app.state.createFromPart = false;
                    createManufacturer.open()
                  "
                      [title]="app.text.manufacturer.createNewManufacturer"
                      >
                      <i class="fas fa-plus"></i>&nbsp;&nbsp;{{ app.text.app.add }}
                    </a>
                  }
                  @case ('Lifecycle') {
                    <span
                      class="badge"
                [ngStyle]="
                  app.field.getColor(
                    app.fieldId.manufacturer.obsolescenceStatus,
                    match[column]
                  )
                "
                      >
                      {{
                      app.field.getOptionText(
                      app.fieldId.manufacturer.obsolescenceStatus,
                      match[column]
                      )
                      }}
                    </span>
                  }
                  @case ('LifecycleStatus') {
                    <span
                      class="badge"
                [ngStyle]="
                  app.field.getColor(
                    app.fieldId.manufacturer.obsolescenceStatus,
                    match[column]
                  )
                "
                      >
                      {{
                      app.field.getOptionText(
                      app.fieldId.manufacturer.obsolescenceStatus,
                      match[column]
                      )
                      }}
                    </span>
                  }
                  @case ('RoHS') {
                    <span
                      class="badge"
                [ngStyle]="
                  app.field.getColor(
                    app.fieldId.manufacturer.euRoHS,
                    match[column]
                  )
                "
                      >
                      {{
                      app.field.getOptionText(
                      app.fieldId.manufacturer.euRoHS,
                      match[column]
                      )
                      }}
                    </span>
                  }
                  @case ('RoHSStatus') {
                    <span
                      class="badge"
                [ngStyle]="
                  app.field.getColor(
                    app.fieldId.manufacturer.euRoHS,
                    match[column]
                  )
                "
                      >
                      {{
                      app.field.getOptionText(
                      app.fieldId.manufacturer.euRoHS,
                      match[column]
                      )
                      }}
                    </span>
                  }
                  @case ('Datasheet') {
                    @if (match.Datasheet) {
                      <a
                        class="datasheet text-center"
                        [href]="match.Datasheet"
                        target="_blank"
                        >
                        <i class="fas fa-file icon-blue"></i>
                      </a>
                    }
                  }
                  @case ('suitable') {
                    <input
                      type="checkbox"
                      class="suitable-checkbox"
                  [checked]="
                    suitableService.isSuitableChecked(matchReviews, match)
                  "
                      [disabled]="isSavingSuitableState"
                      (change)="setSuitableValue(match, $event)"
                  [attr.title]="
                    suitableService.isSuitableChecked(matchReviews, match)
                      ? 'Not suitable'
                      : null
                  "
                      aria-label="Not suitable"
                      />
                  }
                  @case ('EstimatedYearsToEOL') {
                    @if (getMatchColumnValue(match, column) != '0') {
                      <span>
                        {{ getMatchColumnValue(match, column) }}
                      </span>
                    }
                  }
                  @case ('MatchReason') {
                    <div class="suitable-note-cell" (click)="$event.stopPropagation()">
                      @if (isEditingSuitableNote(match)) {
                        <input
                          #suitableNoteInput
                          type="text"
                          class="form-control form-control-sm suitable-note-input"
                          [(ngModel)]="suitableNoteDrafts[match.PartID]"
                          [attr.data-part-id]="match.PartID"
                          (keydown.enter)="saveSuitableNote(match)"
                          />
                        <button
                          class="suitable-note-icon"
                          (click)="saveSuitableNote(match)"
                          [disabled]="isSavingSuitableNote(match)"
                          [title]="app.text.modal.ok"
                          >
                          <i class="fas fa-check"></i>
                        </button>
                      } @else {
                        <span class="suitable-note-text">
                          <app-limit
                            [textInput]="suitableService.getSuitableNote(matchReviews, match)"
                            limit="20"
                            >
                          </app-limit>
                        </span>
                        <button
                          class="suitable-note-icon"
                          (click)="startEditingSuitableNote(match)"
                      [disabled]="
                        !suitableService.isSuitableChecked(matchReviews, match)
                      "
                      [title]="
                        suitableService.getSuitableNote(matchReviews, match)
                          ? app.text.app.edit
                          : 'Leave note'
                      "
                          >
                          <i
                            class="fas"
                        [ngClass]="
                          suitableService.getSuitableNote(matchReviews, match)
                            ? 'fa-pen'
                            : 'fa-plus'
                        "
                          ></i>
                        </button>
                      }
                    </div>
                  }
                  @case ('matchReason') {
                    <div class="suitable-note-cell" (click)="$event.stopPropagation()">
                      @if (isEditingSuitableNote(match)) {
                        <input
                          #suitableNoteInput
                          type="text"
                          class="form-control form-control-sm suitable-note-input"
                          [(ngModel)]="suitableNoteDrafts[match.PartID]"
                          [attr.data-part-id]="match.PartID"
                          (keydown.enter)="saveSuitableNote(match)"
                          />
                        <button
                          class="suitable-note-icon"
                          (click)="saveSuitableNote(match)"
                          [disabled]="isSavingSuitableNote(match)"
                          [title]="app.text.modal.ok"
                          >
                          <i class="fas fa-check"></i>
                        </button>
                      } @else {
                        <span class="suitable-note-text">
                          <app-limit
                            [textInput]="suitableService.getSuitableNote(matchReviews, match)"
                            limit="40"
                            >
                          </app-limit>
                        </span>
                        <button
                          class="suitable-note-icon"
                          (click)="startEditingSuitableNote(match)"
                      [disabled]="
                        !suitableService.isSuitableChecked(matchReviews, match)
                      "
                      [title]="
                        suitableService.getSuitableNote(matchReviews, match)
                          ? app.text.app.edit
                          : 'Leave note'
                      "
                          >
                          <i
                            class="fas"
                        [ngClass]="
                          suitableService.getSuitableNote(matchReviews, match)
                            ? 'fa-pen'
                            : 'fa-plus'
                        "
                          ></i>
                        </button>
                      }
                    </div>
                  }
                  @case ('select') {
                    @if (
                      showDefaultBtn(app.manufacturerMatching.manufacturer, match)) {
                      <button
                        class="btn btn-sm btn-select-match"
                    (click)="
                      saveMatchModal.open();
                      app.externalDataFilter.currentMatch = match
                    "
                        [disabled]="!app.permission.manufacturer.canMatch"
                        >
                        <i class="fa-thin fa-box-check"></i>&nbsp;{{
                        app.text.matchingManufacturer.createMatch
                        }}
                      </button>
                    } @else {
                      <button
                        class="btn btn-sm btn-matched"
                        (click)="unMatchModal.open()"
                        [disabled]="!app.permission.manufacturer.canMatch"
                        [title]="app.text.matchingManufacturer.selected"
                        >
                        <i class="fa-solid fa-link"></i>&nbsp;{{
                        app.text.RM.matched
                        }}
                      </button>
                    }
                  }
                  @case ('assignedTo') {
                    @if (match.isAdded) {
                      <i
                        class="fas fa-sitemap fa-rotate-270 icon-blue pointer p-1"
                  (click)="
                    app.manufacturer.selectedManufacturer = match;
                    seeAssignedToModal.open()
                  "
                      ></i>
                    }
                  }
                  @case ('createCase') {
                    @if (app.permission.thread.hasPermissionToCreateThread) {
                      @if (!app.thread.getCase(match)) {
                        <i
                          class="far fa-folder-plus icon-blue pointer p-1"
                    (click)="
                      app.externalDataFilter.newCase(match, partNumber);
                      app.externalDataFilter.currentMatch = match
                    "
                        ></i>
                      }
                      @if (app.thread.getCase(match)) {
                        <i
                          class="fas fa-folder-open icon-blue pointer p-1"
                    (click)="
                      seeOpenedCasesModal.open();
                      app.externalDataFilter.selectedMatch = match;
                      app.thread.getCasesByPartNumber(match)
                    "
                        ></i>
                      }
                    }
                  }
                  @default {
                    @if (!app.manufacturerMatching.isSpecialColumn(column)) {
                      <span>
                        @if (showValue(column, getMatchColumnValue(match, column))) {
                          <span>
                            {{ getMatchColumnValue(match, column) }}
                          </span>
                        }
                      </span>
                    }
                  }
                }
              </td>
            }
          </tr>
        }
        @if (
          (!manufacturerId && app.externalDataFilter.matches.length === 0) ||
          (app.manufacturerMatching.manufacturer.matches &&
          app.manufacturerMatching.manufacturer.matches.length === 0)
          ) {
          <tr
            >
            <td
              [attr.colspan]="columnRows.length || 10"
              class="text-center external-empty-state"
              >
              {{ app.text.matchingManufacturer.noResults }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (app.externalDataFilter.totalResults > 0) {
    <div
      class="external-table-pagination"
      >
      <div class="external-pagination-summary">
        Showing {{ app.externalDataFilter.displayedResultCount }} of
        {{ app.externalDataFilter.totalResults }} results
      </div>
      <div class="external-pagination-controls">
        <button
          type="button"
          class="external-pagination-button"
          [disabled]="!app.externalDataFilter.hasPreviousPage"
          (click)="app.externalDataFilter.goToPreviousPage()"
          aria-label="Previous page"
          >
          <i class="far fa-chevron-left"></i>
        </button>
        <span class="external-pagination-page">
          {{ app.externalDataFilter.displayedCurrentPage }}
        </span>
        <button
          type="button"
          class="external-pagination-button"
          [disabled]="!app.externalDataFilter.hasNextPage"
          (click)="app.externalDataFilter.goToNextPage()"
          aria-label="Next page"
          >
          <i class="far fa-chevron-right"></i>
        </button>
      </div>
    </div>
  }
</div>

<app-modal
  #seeOpenedCasesModal
  [modalTitle]="app.text.thread.threads"
  [modalType]="'showListOfCases'"
  [showButtons]="false"
  >
</app-modal>
<app-modal
  #seeAssignedToModal
  [modalTitle]="app.text.app.assignedTo"
  [modalType]="'assignedTo'"
  [showButtons]="false"
  >
</app-modal>

<app-modal
  #confirmUnsuitableModal
  [modalTitle]="app.text.app.confirm"
  [modalMessage]="suitableConfirmModalMessage"
  (ok)="confirmMarkAsNotSuitable()"
  >
  <div class="text-start mt-3">
    <app-field
      [model]="unsuitableNoteModel"
      [field]="app.fieldId.matchingManufacturer.matchReason"
      >
    </app-field>
  </div>
</app-modal>

<app-modal
  #confirmAllUnsuitableModal
  [modalTitle]="app.text.app.confirm"
  [modalMessage]="
    app.text.matchingManufacturer.markAllMatchesAsNotSuitableConfirm
  "
  (ok)="confirmMarkAllAsNotSuitable()"
  >
  <div class="text-start mt-3">
    <app-field
      [model]="unsuitableNoteModel"
      [field]="app.fieldId.matchingManufacturer.matchReason"
      >
    </app-field>
  </div>
</app-modal>

<app-modal
  #confirmUnmarkAllSuitableModal
  [modalTitle]="app.text.app.confirm"
  [modalMessage]="app.text.matchingManufacturer.unmarkAllMatchesAsNotSuitableConfirm"
  (ok)="confirmUnmarkAllSuitable()"
  >
  <div class="text-start mt-3">
    <app-field
      [model]="unsuitableNoteModel"
      [field]="app.fieldId.matchingManufacturer.matchReason"
      >
    </app-field>
  </div>
</app-modal>
